import * as React from 'react';

import type {SalesAutomationTaskTemplate as SalesAutomationTaskTemplateFragment} from 'nutshell-graphql-types';

import {TodoTemplateCard} from './todo-template-card';

type Props = {
    index: number;
    parentId: string;
    taskTemplate: SalesAutomationTaskTemplateFragment;
};

export function TaskTemplateCard(props: Props) {
    return (
        <TodoTemplateCard
            type='closedLeadTaskTemplates'
            index={props.index}
            parentId={props.parentId}
            todoTemplate={props.taskTemplate}
            isDraggable={false}
        />
    );
}
